import React, { useState, useEffect } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { setUser } from "../utils/auth"
import APIS from "../utils/APIS"

const Login = () => {
  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState()

  // Point 16 : icone œil sur tous les champs de mot de passe
  const [showPassword, setShowPassword] = useState(false)

  return (
    <>
      <Helmet>
        <title>Connexion | TheScan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: '',
              password: ''
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email("Veuillez renseigner votre email").max(255).required('Veuillez renseigner votre email'),
              password: Yup.string().max(255).required('Veuillez renseigner votre mot de passe')
            })}
            onSubmit={(values, { setSubmitting }) => {
              setAlertMessage("");
              const user = { email: values.email, password : values.password, type:"RisUpTheScan2025" }
              APIS.postUserLogin(user).then(result => {
                if (!result.err) {
                  if (result.data.message == "signin") {
                    setUser(result.data.user)
                    navigate("/")
                    //console.log("connection réussi");
                  } else {
                    let errors = result?.data?.message
                    if (errors?.emailnotfound === true) {
                      setAlertMessage("L'adresse email est incorrecte")
                    } else if (errors?.passwordincorrect === true) {
                      setAlertMessage("Le mot de passe est incorrect");
                    } else {
                      setAlertMessage("Identifiant ou mot de passe incorrect")
                    }
                    setSubmitting(false);
                  }
                } else {
                  setAlertMessage("Erreur inconue");
                  setSubmitting(false);
                }
              });
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box sx={{ mb: 2, textAlign:"center" }}>
                  <Typography
                    color="textBlack"
                    variant="h2"
                  >
                    Connexion
                  </Typography>
                </Box>

                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="Adresse email"
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="email"
                  value={values.email}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Mot de passe"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type={showPassword ? "text" : "password"}
                  value={values.password}
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="afficher le mot de passe"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                <Box sx={{ py: 2 }}>
                  <Button
                    color="primary"
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    endIcon={<ChevronRightIcon/>}
                  >
                    Se connecter
                  </Button>
                </Box>
                <Box sx={{
                  marginTop:"15px",
                  marginBottom:"15px",
                  fontSize:"16px",
                  textAlign:"center",
                  color : "text.primary",
                }}>
                  {/* Point 15 : le lien dit ce qu'il fait */}
                  Mot de passe oublié&nbsp;?
                  <Link component={RouterLink} to="/forgotPassword" sx={{marginLeft:"3px"}}>
                    Réinitialiser mon mot de passe
                  </Link>
                </Box>
                {alertMessage && alertMessage.length > 0 && (
                  <Box
                    sx={{
                      pb: 1,
                      pt: 0
                    }}
                  >
                    <Typography
                      align="center"
                      color="red"
                      variant="body1"
                    >
                      {alertMessage}
                    </Typography>
                  </Box>
                )}
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </>
  );
};

export default Login;
